import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=8329e61e"
import script from "./Inventories.vue?vue&type=script&lang=js"
export * from "./Inventories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports